<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em;">I’d like to thank my family and friends, for putting up with my neuroticism which, in effect, led to these poems.</p>
<br/>
<p style="text-indent:00em;">My parents and husband, for the encouragement that gave me the confidence to get my work out into the public eye; for that I am forever grateful.</p>
<br/>
<p style="text-indent:00em;">I would also like to thank all the staff at Austin Macauley Publishers, without whom this would not have been possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?57178881